import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AbstractFormComponent, FieldDateComponent, FieldNumberComponent, FieldSelectComponent, FieldTextAreaComponent } from '@spike/scaffolds';
import { TableModule } from "primeng/table";
import { startWith, switchMap } from 'rxjs';
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { OrganizationListComponent } from '../../../organizations/components/organization-list/organization-list';
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-position-working-phase-form',
  providers:[],
  imports: [ReactiveFormsModule, CommonModule, FormsModule, TableModule, FieldDateComponent, FieldNumberComponent, FieldTextAreaComponent, FieldSelectComponent, OrganizationListComponent],
  templateUrl: './position-working-phase-form.html'
})
export class PositionWorkingPhaseFormComponent extends AbstractFormComponent{
  public readonly organizationStore = inject(OrganizationStoreService);

  public readonly workflowPhase = input.required<number>()
  public employeeEtiquetteApi = EtiquetteApiEnum.EMPLOYEE;
  public employeeModelApi = ModelApiEnum.EMPLOYEE;
  public employeeApi = EntityApiEnum.EMPLOYEE;


  private readonly formValues = toSignal(
    toObservable(this.form).pipe(
      switchMap(form => form.valueChanges.pipe(
        startWith(form.getRawValue())
      ))
    )
  );
  


  constructor() {
    super();
    effect(() => {
      // 1. Leggiamo il valore del segnale (si aggiorna ad ogni cambio del form)
      const values = this.formValues();
      
      // 2. Recuperiamo l'istanza attuale del form (necessaria per il patchValue)
      const formGroup = this.form();

      if (values && formGroup) {
        const total = values.total ?? 0;
        const totalCalculated = values.totalCalculated ?? 0;
        // 3. Logica di calcolo del margine
        if (totalCalculated > 0) {
          const margin = parseFloat(((total - totalCalculated) / totalCalculated * 100).toFixed(2));
          
          
       
          // 4. Aggiornamento del controllo
          // Verifichiamo che il valore sia diverso per evitare cicli inutili
          if (values.profitMarginPerc !== margin) {
            formGroup.get('profitMarginPerc')?.patchValue(margin, { emitEvent: false });
          }
       }
      }
    });
  }
}